import classNames from 'classnames';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import Flex from '../../../../../components/common/Flex';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import IconButton from '../../../../../components/common/IconButton';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { obtenerIconoVehiculo } from '../../../../../components/common/google-maps-selector/IconosTabla';


const Project = ({ project, isLast, onSelectVehicle, highlighted }) => {
    const { color, progress, totalAlerts, title } = project;

    // Determinar si es hexadecimal (empieza con #) o nombre de color Bootstrap
    const isHexColor = color.startsWith('#');

    // Mapear colores hexadecimales comunes a colores de Bootstrap (opcional)
    const mapHexToBootstrap = (hex) => {
        const colorMap = {
            '#0d6efd': 'primary',
            '#198754': 'success',
            '#ffc107': 'warning',
            '#dc3545': 'danger',
            '#0dcaf0': 'info',
            '#6c757d': 'secondary',
            '#adb5bd': 'light',
            '#212529': 'dark'
        };
        return colorMap[hex.toLowerCase()] || 'primary'; // Default a primary si no hay coincidencia
    };

    // Para el avatar y texto, usar estilo inline si es hex, o clases Bootstrap si es nombre
    const avatarStyle = isHexColor ? { backgroundColor: `${color}20` } : {}; // 20 = 12% opacidad para el fondo
    const textStyle = isHexColor ? { color: color } : {};

    // Clase para el avatar - usar clases Bootstrap solo si no es hexadecimal
    const avatarClass = isHexColor
        ? 'avatar-name rounded-circle'
        : `avatar-name rounded-circle bg-${color}-subtle`;

    // Clase para el texto - usar clases Bootstrap solo si no es hexadecimal
    const textClass = isHexColor
        ? 'fs-9'
        : `fs-9 text-${color.split('-')[1] || color}`;

    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    return (
        <div>
            <Row
                className={classNames(
                    'position-relative align-items-center py-2 ps-3 g-0 flex-nowrap',
                    { 'border-bottom border-200': !isLast },
                    { 'text-danger fw-bold': highlighted }
                )} style={{ minWidth: '350px' }} href="#!" onClick={(e) => {
                    e.preventDefault();
                    onSelectVehicle({ title: project.title, id: project.id });
                }}
            >
                {obtenerIconoVehiculo(project.tipo_vehiculo, project.color_vehiculo)}
                <Col className="py-1 px-3 ps-x1">
                    <Flex className="justify-content-between" >
                        <Row className='mx-0 px-0' style={{ width: '55%' }}>
                            <Flex className={classNames(
                                'm-0 p-0 align-items-center text-truncate flex-grow-1 flex-nowrap',
                                { 'fw-bold': highlighted }
                            )} tag="h6" style={{ ...style }}>
                                <a className={classNames('label-detail-card px-0 mx-0', {
                                    'fw-bold': highlighted
                                })}
                                    style={{ fontSize: '14px', ...style }}
                                    title={title}>
                                    {title}
                                </a>
                            </Flex>
                        </Row>
                        <Row className="justify-content-end text-end mx-2 g-0 flex-nowrap justify-content-between" style={{ width: '45%', minWidth: '200px' }} >

                            <div className='mx-2 text-start' style={{ width: '60px' }}>
                                <Badge pill bg="200" className="text-primary" style={{ width: '60px' }}>
                                    {progress}%
                                </Badge>
                            </div>
                            <div className="justify-content-end d-flex flex-nowrap" style={{ width: '60%' }}>

                                <Badge pill bg="200">
                                    <div className="m-0 fs-10 fw-semibold text-primary">{(totalAlerts).toLocaleString('es-MX')} alertas</div>
                                </Badge>
                                <a className="ms-2 text-800" >
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                            </div>
                        </Row>
                    </Flex>
                </Col >
            </Row >
        </div >
    );
};

Project.propTypes = {
    project: PropTypes.shape({
        color: PropTypes.string.isRequired,
        progress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        totalAlerts: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired
    }),
    isLast: PropTypes.bool,
    onSelectVehicle: PropTypes.func.isRequired,
    highlighted: PropTypes.bool
};

/**
 * Componente que muestra alertas agrupadas por vehículo
 * Ahora recibe directamente los datos agrupados del worker maestro
 */
const AlertaVehiculo = ({ data, total, onSelectVehicle, highlightedVehicle, vehiculoFiltrado, handleFiltro }) => {

    // Ya no usamos worker interno, ahora recibimos data ya agrupada
    let totalAlertas = data.reduce((total, data) => {
        const distancia = data.totalAlerts;
        return total + (isNaN(distancia) ? 0 : distancia);
    }, 0);

    return (
        <Card className="h-100">
            <FalconCardHeader
                title={vehiculoFiltrado != null ? `Alertas por vehículo: ${highlightedVehicle}` : "Alertas por vehículo"}
                light
                titleTag="h6"
                endEl={vehiculoFiltrado != null && (<IconButton onClick={handleFiltro} icon="times-circle" size="sm" variant="falcon-default">Remover filtro</IconButton>)}
            />

            <Card.Body className="p-0" >
                <div className="overflow-auto" style={{ maxHeight: '300px' }}>
                    {data.map((project, index) => (
                        <Project
                            project={project}
                            isLast={index === data.length - 1}
                            key={project.id || index}
                            onSelectVehicle={onSelectVehicle}
                            highlighted={highlightedVehicle === project.title}
                        />
                    ))}
                </div>
            </Card.Body>

            <Card.Footer className='py-0'>
                <Row className='px-1 pb-2 justify-content-end'>
                    <Col md={12} className='text-end '>
                        <div className="fw-bold label-detail-card"> Total de alertas: {(totalAlertas).toLocaleString('es-MX')}</div>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>
    );
};

AlertaVehiculo.propTypes = {
    // Ahora esperamos un array de objetos ya agrupados con este formato
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string.isRequired,
        totalAlerts: PropTypes.number.isRequired,
        progress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        color: PropTypes.string.isRequired
    })).isRequired,
    total: PropTypes.number,
    onSelectVehicle: PropTypes.func.isRequired,
    highlightedVehicle: PropTypes.string,
    vehiculoFiltrado: PropTypes.string,
    handleFiltro: PropTypes.func
};

export default AlertaVehiculo;